export const streetDirections = ["S", "SE", "N", "NW", "W", "SW", "NE", "E"]